// /preview/invitation/dw001-amora/schemaDummy.js

export const schemaDummy = {
    templateMeta: {
        name: "DW Amora",
        author: "daffaaptar",
        version: "1.0.0",
        brideFirstName: "Isabella",
        brideLastName: "Chen",
        groomFirstName: "Jason",
        groomLastName: "Lim",
        marriageContractDate: "2026-05-30T08:00:00", // Optional - default empty. Fill to show Marriage Contract event
        marriageContractTimeEnd: "10:00", // NEW
        receptionDate: "2026-05-30T11:00:00", // Optional - default empty. Fill to show Reception event
        receptionTimeEnd: "13:00", // NEW
        countdownSource: "marriage", // "marriage" or "reception" - determines which date to use for countdown
        media: {
            videoBackground: "https://cdn.dw.meis.cloud/invitations/dw-amora/f296207d1b6933d237f4a9a14d196f0c590e2dd22d9e78f52e64da47b7d577f943009e526534321c37219763c188acecd9533c5893cf2a97d922b85a4db447c3.dwv",
            audioBackground: "https://cdn.dw.meis.cloud/invitations/dw-amora/d59c8d0f069849c3014c021f8bf321839068bc726133718f499b41633ad22b3799dc3262299b1683112426de90a51aa9712c0e832b893cd4a563e3582391e864.dwm",
            imagesBackground: [],
        },
    },
    desktopCoverConfig: {
        type: "desktopCover",
        title: "Desktop Cover",
        subtitle: "Bagian cover khusus untuk tampilan laptop/desktop. Tidak tampil di HP.",
        props: {
            subtitle: "Our Wedding Day",
            backgroundImage:
                "https://images.unsplash.com/photo-1624644722848-5046bb354f37?q=80&w=1469&auto=format&fit=crop&ixlib=rb-4.1.0&ixid=M3wxMjA3fDB8MHxwaG90by1wYWdlfHx8fGVufDB8fHx8fA%3D%3D",
        },
        schema: {
            fields: [
                { name: "subtitle", type: "text" },
                { name: "backgroundImage", type: "file" },
            ],
        },
    },
    openInvitationConfig: {
        type: "openInvitation",
        title: "Open Invitation",
        subtitle: "Halaman pembuka undangan sebelum masuk ke konten utama.",
        props: {
            title: "The Wedding of",
            subtitle: "With hearts full of love and hands joined in unity, we joyfully invite you to celebrate the beginning of our forever.",
            backgroundImage:
                "https://images.unsplash.com/photo-1630673460748-7c134484fa58?q=80&w=1374&auto=format&fit=crop&ixlib=rb-4.1.0&ixid=M3wxMjA3fDB8MHxwaG90by1wYWdlfHx8fGVufDB8fHx8fA%3D%3D",
            dateFormat: "long",
            buttonText: "Open Invitation",
        },
        schema: {
            fields: [
                { name: "title", type: "text" },
                { name: "subtitle", type: "textarea" },
                { name: "backgroundImage", type: "file" },
                { name: "dateFormat", type: "dateformat", label: "Date Display Format", defaultValue: "long" },
                { name: "buttonText", type: "text" },
            ],
        },
    },
    sectionSchemas: {
        hero: {
            fields: [
                { name: "images", type: "list:file" },
                { name: "heading", type: "text" },
                { name: "dateFormat", type: "dateformat", label: "Date Display Format", defaultValue: "long" },
                { name: "description", type: "textarea" },
            ],
        },
        couple: {
            fields: [
                {
                    name: "bridegroom",
                    type: "list:object",
                    removable: false,
                    fields: [
                        { name: "role", type: "text" },
                        { name: "image", type: "file" },
                        { name: "description", type: "textarea" },
                    ],
                },
            ],
        },
        journey: {
            fields: [
                { name: "dateFormat", type: "dateformat", label: "Date Display Format", defaultValue: "long" },
                { name: "video", type: "file" },
                { name: "heading", type: "text" },
                {
                    name: "steps",
                    type: "list:object",
                    fields: [
                        { name: "title", type: "text" },
                        { name: "date", type: "datetime" },
                        { name: "description", type: "textarea" },
                    ],
                },
            ],
        },
        gallery: {
            fields: [
                { name: "heading", type: "text" },
                { name: "subtitle", type: "text" },
                { name: "images", type: "list:file" },
            ],
        },
        events: {
            fields: [
                { name: "heading", type: "text" },
                { name: "subtitle", type: "text" },
                {
                    name: "events",
                    type: "list:object",
                    removable: false,
                    fields: [
                        { name: "title", type: "text" },
                        { name: "dateFormat", type: "dateformat", label: "Date Display Format", defaultValue: "long" },
                        { name: "venue", type: "text" },
                        { name: "address", type: "text" },
                        { name: "image", type: "file" },
                    ],
                },
                {
                    name: "dresscode",
                    type: "object",
                    fields: [
                        { name: "heading", type: "text" },
                        { name: "subtitle", type: "text" },
                        { name: "image", type: "file" },
                        { name: "colors", type: "list:color" },
                    ],
                },
            ],
        },
        rsvp: {
            fields: [
                { name: "backgroundImage", type: "file" },
                { name: "heading", type: "text" },
                { name: "subtitle", type: "text" },
                { name: "wishesHeading", type: "text" },
                { name: "wishesSubtitle", type: "text" },
                { name: "virtualBoothImage", type: "file" },
            ],
        },
        gifts: {
            fields: [
                { name: "heading", type: "text" },
                { name: "subtitle", type: "text" },
                {
                    name: "transfers",
                    type: "list:object",
                    fields: [
                        { name: "name", type: "text" },
                        { name: "bank", type: "bank" },
                        { name: "no", type: "text" },
                    ],
                },
                {
                    name: "gifts",
                    type: "list:object",
                    fields: [
                        { name: "image", type: "file" },
                        { name: "title", type: "text" },
                        { name: "amount", type: "number" },
                        { name: "price", type: "text" },
                        { name: "purchaseLink", type: "text" },
                    ],
                },
            ],
        },
        thankyou: {
            fields: [
                { name: "heading", type: "text" },
                { name: "message", type: "textarea" },
            ],
        },
        quote: {
            fields: [
                { name: "quoteText", type: "textarea" },
                { name: "quoteAuthor", type: "text" },
            ],
        },
    },
    defaultSections: [
        {
            id: "hero-1",
            type: "hero",
            enabled: true,
            order: 1,
            props: {
                images: [
                    "https://images.unsplash.com/photo-1630673460505-df28b460d5a1?q=80&w=1374&auto=format&fit=crop",
                    "https://images.unsplash.com/photo-1630673271191-a1d70a107658?q=80&w=1483&auto=format&fit=crop",
                    "https://images.unsplash.com/photo-1630673271171-a81cd9137120?q=80&w=1374&auto=format&fit=crop",
                ],
                interval: 3000,
                heading: "The Wedding of",
                dateFormat: "long",
                description:
                    "With hearts full of love and hands joined in unity, we joyfully invite you to celebrate the beginning of our forever",
                showChevron: true,
            },
        },
        {
            id: "couple-1",
            type: "couple",
            enabled: true,
            order: 2,
            props: {
                bridegroom: [
                    {
                        role: "The Groom",
                        image:
                            "https://images.unsplash.com/photo-1610686544711-8f16ba676d31?q=80&w=1376&auto=format&fit=crop",
                        description:
                            "He walks with purpose, speaks with warmth, and loves deeply. Ready to start a lifelong journey hand in hand with the one he cherishes most.",
                    },
                    {
                        role: "The Bride",
                        image:
                            "https://images.unsplash.com/photo-1611971276877-82f98d9218d8?q=80&w=1376&auto=format&fit=crop",
                        description:
                            "She lights up every room with her laughter and carries warmth in everything she does. Now stepping into a new chapter with love by her side.",
                    },
                ],
            },
        },
        {
            id: "journey-1",
            type: "journey",
            enabled: true,
            order: 3,
            props: {
                dateFormat: "long",
                video: "https://cdn.dw.meis.cloud/invitations/dw-amora/f296207d1b6933d237f4a9a14d196f0c590e2dd22d9e78f52e64da47b7d577f943009e526534321c37219763c188acecd9533c5893cf2a97d922b85a4db447c3.dwv",
                heading: "Our Love Story",
                steps: [
                    {
                        title: "First Met",
                        date: "12 January 2018",
                        description:
                            "Kami pertama kali bertemu di kampus saat mengikuti kegiatan organisasi mahasiswa. Dari pertemuan itulah, percakapan-percakapan kecil mulai terjalin dan perlahan tumbuh menjadi ikatan yang lebih dalam",
                    },
                    {
                        title: "Officially Dating",
                        date: "22 March 2019",
                        description:
                            "Kami resmi berpacaran setelah melewati banyak momen kebersamaan. Dari obrolan sederhana hingga saling menguatkan di masa sulit, akhirnya kami memutuskan untuk melangkah bersama sebagai pasangan yang lebih dari sekadar teman.",
                    },
                    {
                        title: "Engaged",
                        date: "17 August 2024",
                        description:
                            "Di tengah perjalanan yang penuh cerita, kami memutuskan untuk melangkah lebih jauh. Dengan restu keluarga dan hati yang mantap, kami bertunangan—menandai babak baru dalam kisah kami menuju pernikahan.",
                    },
                    {
                        title: "Wedding Day",
                        date: "21 October 2025",
                        description:
                            "Hari yang kami nanti akhirnya tiba. Dikelilingi orang-orang tercinta, kami mengikat janji suci sebagai pasangan seumur hidup. Sebuah awal baru yang penuh harapan, cinta, dan doa untuk masa depan bersama.",
                    },
                ],
            },
        },
        {
            id: "events-1",
            type: "events",
            enabled: true,
            order: 4,
            props: {
                heading: "Ceremony & Celebration",
                subtitle: "A Day of Love, Promise, and Celebration",
                events: [
                    {
                        title: "Akad Nikah",
                        dateFormat: "long",
                        venue: "The House by Canggu",
                        address: "Jl. Bukit Pakar Timur No.7, Ciburial, Cimenyan, Bandung",
                        image: "https://images.unsplash.com/photo-1611374479457-75461cea4768?q=80&w=1526&auto=format&fit=crop&ixlib=rb-4.1.0&ixid=M3wxMjA3fDB8MHxwaG90by1wYWdlfHx8fGVufDB8fHx8fA%3D%3D",
                        ctas: [
                            { label: "Save the Date", href: "#" },
                            { label: "Maps", href: "#" },
                        ],
                    },
                    {
                        title: "Wedding Reception",
                        dateFormat: "long",
                        venue: "Green Hills",
                        address: "Jl. Sersan Bajuri No.102, Parongpong, Bandung Barat",
                        image: "https://images.unsplash.com/photo-1611971122753-c3c7703674e2?q=80&w=1469&auto=format&fit=crop&ixlib=rb-4.1.0&ixid=M3wxMjA3fDB8MHxwaG90by1wYWdlfHx8fGVufDB8fHx8fA%3D%3D",
                        ctas: [
                            { label: "Save the Date", href: "#" },
                            { label: "Maps", href: "#" },
                        ],
                    },
                ],
                dresscode: {
                    heading: "Dresscode",
                    subtitle: "Kindly dress in elegance and harmony with our wedding theme.",
                    image: "https://images.unsplash.com/photo-1615496432010-6733fa3f73b7?q=80&w=1469&auto=format&fit=crop&ixlib=rb-4.1.0&ixid=M3wxMjA3fDB8MHxwaG90by1wYWdlfHx8fGVufDB8fHx8fA%3D%3D",
                    colors: ["#ffffff", "#D8DBBD", "#410200", "#000000"],
                },
            },
        },
        {
            id: "rsvp-1",
            type: "rsvp",
            enabled: true,
            order: 5,
            props: {
                backgroundImage: "https://images.unsplash.com/photo-1624644722848-5046bb354f37?q=80&w=1469&auto=format&fit=crop",
                heading: "RSVP",
                subtitle: "Please RSVP to confirm your attendance at our wedding day.",
                wishesHeading: "Wishes & Prayers",
                wishesSubtitle: "Thank you for your kind words, warm wishes, and heartfelt prayers",
                virtualBoothImage: "https://images.unsplash.com/photo-1700157679224-56c9f3d15118?q=80&w=1469&auto=format&fit=crop",
                countdownDate: "2025-12-29T08:00:00",
                initialWishes: [
                    {
                        name: "Dina & Raka",
                        message: "Selamat menempuh hidup baru! Semoga langgeng dan bahagia selalu!",
                        attendance: "hadir",
                    },
                    {
                        name: "Adit",
                        message: "Maaf ga bisa hadir, tapi doa terbaik selalu untuk kalian berdua ❤️",
                        attendance: "tidak_hadir",
                    },
                    {
                        name: "Anggun",
                        message: "Ga sabar buat ketemu kalian berdua nanti!",
                        attendance: "hadir",
                    },
                ],
            },
        },
        {
            id: "quote-1",
            type: "quote",
            enabled: true,
            order: 6,
            props: {
                quoteText: "Dan di antara tanda-tanda (kebesaran)-Nya ialah Dia menciptakan untukmu pasangan hidup dari jenismu sendiri supaya kamu merasa tenteram kepadanya, dan Dia menjadikan di antaramu rasa kasih dan sayang. Sungguh, pada yang demikian itu benar-benar terdapat tanda-tanda (kebesaran Allah) bagi kaum yang berpikir.",
                quoteAuthor: "— QS. Ar-Rum: 21",
            },
        },
        {
            id: "gallery-1",
            type: "gallery",
            enabled: true,
            order: 7,
            props: {
                heading: "Our Prewedding Celebration",
                subtitle: "A Chapter Before “I Do”",
                interval: 5000,
                images: [
                    "https://images.unsplash.com/photo-1488600779855-8151a2b2e4eb?q=80&w=1470&auto=format&fit=crop",
                    "https://images.unsplash.com/photo-1617725145063-56958eadf557?q=80&w=1389&auto=format&fit=crop",
                    "https://images.unsplash.com/photo-1624067066096-df6f20a2902f?q=80&w=1470&auto=format&fit=crop",
                    "https://images.unsplash.com/photo-1700157679224-56c9f3d15118?q=80&w=1469&auto=format&fit=crop",
                    "https://images.unsplash.com/photo-1558006662-4ecd54aaece3?q=80&w=1470&auto=format&fit=crop",
                    "https://images.unsplash.com/photo-1533417020304-c785906cd8f9?q=80&w=1470&auto=format&fit=crop",
                    "https://images.unsplash.com/photo-1591078855982-0fc3afdbae24?q=80&w=1470&auto=format&fit=crop",
                ],
            },
        },
        {
            id: "gifts-1",
            type: "gifts",
            enabled: true,
            order: 8,
            props: {
                heading: "E-Gifts",
                subtitle: "Your presence is our present, but if you wish to give a gift",
                transfers: [
                    { name: "Isabella", bank: "Bank BCA", no: "0551555222" },
                    { name: "Jason", bank: "Bank Mandiri", no: "1902471231823712" },
                ],
                gifts: [
                    {
                        image: "https://images.pexels.com/photos/276583/pexels-photo-276583.jpeg",
                        title: "Sofa Minimalis L Putus Classie - Mocha",
                        amount: 2,
                        price: "Rp 2.250.000",
                        purchaseLink: ""
                    },
                    {
                        image: "https://images.pexels.com/photos/276556/pexels-photo-276556.jpeg",
                        title: "Sprei Sultan Waterproof",
                        amount: 1,
                        price: "Rp 165.800",
                        purchaseLink: ""
                    },
                    {
                        image: "https://images.pexels.com/photos/276589/pexels-photo-276589.jpeg",
                        title: "Handuk Bamboo Soft Premium",
                        amount: 3,
                        price: "Rp 49.900",
                        purchaseLink: ""
                    },
                    {
                        image: "https://images.pexels.com/photos/276595/pexels-photo-276595.jpeg",
                        title: "Paket Cooking Starter Set",
                        amount: 1,
                        price: "Rp 399.000",
                        purchaseLink: ""
                    },
                ],
            },
        },
        {
            id: "thankyou-1",
            type: "thankyou",
            enabled: true,
            order: 9,
            props: {
                heading: "Thank You",
                message:
                    "Terima kasih atas doa dan restu yang diberikan. Semoga kehadiran Bapak/Ibu/Saudara/i menjadi berkah yang memperindah hari bahagia kami.",
            },
        },
    ]
};
